import { LINKS } from 'common/brandMetadata/links/links';
import { useMemo } from 'react';

interface MoreLink {
  label: string;
  description: string;
  href: string;
  external: boolean;
}

export function getMoreLinks(
  links: Record<string, string | undefined>,
): MoreLink[] {
  const moreLinks: MoreLink[] = [];

  if (links.marketingSite) {
    moreLinks.push({
      label: 'Website',
      description: 'Visit the official landing page',
      href: links.marketingSite,
      external: true,
    });
  }

  if (links.termsOfUse) {
    moreLinks.push({
      label: 'Terms of Use',
      description: 'Legal terms and conditions',
      href: links.termsOfUse,
      external: true,
    });
  }

  return moreLinks;
}

// Shared between mobile and desktop more links. Mobile is a Collapsible whereas Desktop is a Popover component.
export function useMoreLinks(): MoreLink[] {
  return useMemo(
    // Use loose typing so brands with a subset of links (e.g. stackd) don't cause TS errors.
    () => getMoreLinks(LINKS as Record<string, string | undefined>),
    [],
  );
}
